module.exports = __webpack_public_path__ + "static/media/nav-knowledge-and-skills-inactive.917286bd.svg";